import PropTypes from 'prop-types';
import React from 'react';
import { LinearProgress } from '@mui/material';

const styles = {
  height: 3,
  zIndex: 1301, // 1300 (MuiModal) + 1
  position: 'absolute',
  width: '100%',
};

/**
 * Used to show a loading progress bar on the top of the page
 */
class LoadingProgress extends React.Component {
  render() {
    if (!this.props.isLoading) {
      return null;
    }

    return (
      <LinearProgress
        variant="query"
        color={this.props.color}
        style={this.props.hideStyle ? {} : styles}
      />
    );
  }
}

LoadingProgress.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};

LoadingProgress.defaultProps = {
  isLoading: false,
  color: 'secondary',
};

export default LoadingProgress;
